import React from 'react';
import cls from 'classnames';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import type { TPAComponentProps } from 'wix-ui-tpa/dist/cssVars/types/types';

import type {
  OverridableComponent,
  OverridableComponentProps,
} from '../OverridableComponent';

import classes from './ListItem.scss';
import { classes as stClasses } from './ListItem.st.css';

interface IListItemProps extends TPAComponentProps {
  children?: React.ReactNode;
  centered?: boolean;
  disablePadding?: boolean;
  disableGutters?: boolean;
  actionOnHover?: boolean;
}

// eslint-disable-next-line react/display-name
export const ListItem = React.forwardRef(
  (props: OverridableComponentProps<IListItemProps, 'li'>, ref) => {
    const {
      as = 'li',
      className,
      centered,
      disablePadding,
      actionOnHover,
      disableGutters,
      ...rest
    } = props;

    const { isMobile } = useEnvironment();

    const Element = as;

    return (
      <Element
        ref={ref}
        className={cls(classes.root, stClasses.root, className, {
          [classes.mobile]: isMobile,
          [classes.centered]: centered,
          [classes.disablePadding]: disablePadding,
          [classes.disableGutters]: disableGutters,
          [stClasses.hideAction]: actionOnHover,
        })}
        {...rest}
      >
        {props.children}
      </Element>
    );
  },
) as OverridableComponent<IListItemProps, 'li'>;

ListItem.displayName = 'wui/ListItem';
ListItem.defaultProps = {
  centered: true,
};
